<script>

import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game2005",
  components: {DescribeLayout},
  props:{
    // bets:[],
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    gongniu_pokers:[],
    gongniu_combine_pokers:[],
    niuzai_pokers:[],
    niuzai_combine_pokers:[],
    common_pokers:[],
    gongniuCardType:0,
    niuzaiCardType:0,
    isShowInfo:false,
    winPos:[],
    bets:[],
    detail:{},
    lang: '',
    Phone:false,
  },
  data()
  {
    return {
      bets:[],
    }
  },
  methods: {
    getNiuzaiType()
    {
      return this.GetCardType(this.niuzaiCardType);
    },
    getGongniuType(type)
    {
      return this.GetCardType(this.gongniuCardType);
    },
    GetCardType(type)
    {
       let name = `lang.str_poker_card_type`+type;
       return name;
    },
    showInfoEvent(isShow)
    {
      this.isShowInfo = isShow;
    }
  }
}
</script>

<template>
    <div>
      <div class="gamebox">
        <div class="top">
          <div class="gametitle">
            {{ $t(`lang.str_detail`) }}
          </div>
        </div>
        <!-- 公牛 -->
        <div class="public ">
          <div class="title">{{ $t(`lang.str_gong_niu`) }}</div>
          <div class="menu">
            <div class="item" v-for="(item,index) in gongniu_pokers" :key="index">
              <img alt=""
                   :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
            </div>
          </div>
          <div class="menu">
            <div class="wintype">
              {{ $t(this.getGongniuType())}}
            </div>
          </div>
        </div>
        <!-- 牛仔 -->
        <div class="public ">
          <div class="title"> {{ $t(`lang.str_niu_zai`) }}</div>
          <div class="menu">
            <div class="item" v-for="(item,index) in niuzai_pokers" :key="index">
              <img alt=""
                   :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
            </div>
          </div>
          <div class="menu">
            <div class="wintype">
              {{$t(this.getNiuzaiType())}}
            </div>
          </div>
        </div>

        <div class="public ">
          <div class="title"> {{ $t(`lang.str_common_pokers`) }}</div>
          <div class="menu">
            <div class="item" v-for="(item,index) in common_pokers" :key="index">
              <img alt=""
                   :src="require('../..//assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
            </div>
          </div>
        </div>
        <div class="top">
          <div class="gametitle">
            {{ $t(`lang.str_betDetail`) }}
          </div>
        </div>
        <div class="jokerbet2 jokerbet3">
          <div>
            <div class="detail">
              <div class="item" v-for="(item, index) in winPos" :key="index">
                    <span v-if="index==0">{{ $t(`lang.str_Gongniu_Win`) }} <span style="color: #ed9108;"
                                                                                 v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==1">{{ $t(`lang.str_NiuzaiWin`) }} <span style="color: #ed9108;"
                                                                           v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==2">{{ $t(`lang.str_Tie`) }} <span style="color: #ed9108;"
                                                                     v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==3">{{ $t(`lang.str_TwoPair`) }} <span style="color: #ed9108;"
                                                                         v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==4">{{ $t(`lang.str_Straight`) }} <span style="color: #ed9108;"
                                                                          v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==5">{{ $t(`lang.str_Flush`) }}
                      <span style="color: #ed9108;" v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==6">{{ $t(`lang.str_FullHouse`) }}
                      <span style="color: #ed9108;" v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
                <span v-if="index==7">{{ $t(`lang.str_Four`) }}
                      <span style="color: #ed9108;" v-if="item==1">({{ $t(`lang.str_bjl_win`) }})</span>
                    </span>
              </div>
            </div>
            <div class="detail">
              <p v-for="(item, index) in winPos" :key="index">
                    <span class="item" v-if="bets">
                      <span v-for="(subitem,subindex) in bets" :key="subindex">
                        <span v-if="subitem.position == index || (!subitem.position && index == 0)">
                          <p v-if="subitem.bet">
                            {{parseFloat(subitem.bet / 100).toFixed(2)}}
                          </p>
                          <p v-else>
                            0
                          </p>
                        </span>
                      </span>
                    </span>
                <span v-else>
                      0
              </span>
              </p>
            </div>
            <div class="detail">
              <div class="item"  v-for="(item, index) in winPos" :key="index">
                <span  v-if="item>0" style="color: #ed9108;">{{ $t(`lang.str_game_win`) }}</span>
                <span v-else> {{ $t(`lang.str_game_fail`) }}</span>
              </div>
            </div>
            <div class="detail">
              <p v-for="(item, index) in winPos" :key="index">
                    <span v-if="bets" class="item">
                      <span v-for="(subitem,subindex) in bets" :key="subindex">
                        <span v-if="subitem.position == index || (!subitem.position && index == 0)">
                          <p v-if="subitem.bet">
                            <span v-if="subitem.win">
                              {{parseFloat((subitem.win-subitem.bet) / 100).toFixed(2)}}
                            </span>
                            <span v-else>
                              -{{parseFloat((subitem.bet) / 100).toFixed(2)}}
                            </span>
                          </p>
                          <p v-else>
                            0
                          </p>
                        </span>
                      </span>
                    </span>
                <span v-else>
                      0
                    </span>
              </p>
            </div>
          </div>
        </div>
        <div id="showInfo" v-show="isShowInfo">
          <div class="top">
            <div class="gametitle">
              {{ $t(`lang.str_detail`) }}
            </div>
          </div>
          <!-- 公牛 -->
          <div class="public ">
            <div class="title">{{ $t(`lang.str_gong_niu`) }}</div>
            <div class="menu">
              <div class="item" v-for="(item,index) in gongniu_combine_pokers" :key="index">
                <img alt=""
                     :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
              </div>
            </div>
            <div class="menu">
              <div class="wintype">
                {{ $t(this.getGongniuType())}}
              </div>
            </div>
          </div>
          <!-- 牛仔 -->
          <div class="public ">
            <div class="title"> {{ $t(`lang.str_niu_zai`) }}</div>
            <div class="menu">
              <div class="item" v-for="(item,index) in niuzai_combine_pokers" :key="index">
                <img alt=""
                     :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
              </div>
            </div>
            <div class="menu">
              <div class="wintype">
                {{$t(this.getNiuzaiType())}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DescribeLayout
        @showInfo-event="showInfoEvent"
        :isShowTool ="isShowInfo"
        :isTotalWin="isTotalWin"
        :winValueTip="winValueTip"
        :winValueTotal="winValueTotal"
        :describe_title="describe_title"
        :describe_content="describe_content"
        :describe_message="describe_message">
      </DescribeLayout>
    </div>
</template>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/joker/game_2005.vue